import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

type InfoPanelDetailDescriptionProps = ComponentProps<'p'>;

export const InfoPanelDetailDescription = memo(({ className, ...props }: InfoPanelDetailDescriptionProps) => (
  <p className={cn('line-clamp-2 ads:text-metadata text-12 text-gray-10', className)} {...props} />
));

InfoPanelDetailDescription.displayName = 'InfoPanelDetailDescription';
